import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { useFloatingSelect } from '../../../../../hooks'
import { useGretaAIChatPopoverClose } from '../../../GretaAIChat.hooks'

export function useGretaAIChatRowMenu({ onOpenChange }) {
  function handleClose() {
    onOpenChange(false)
  }

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({
      placement: FLOATING_ELEMENT_PLACEMENT.bottom,
      onClose: handleClose,
    })

  const { domReference } = refs

  useGretaAIChatPopoverClose({ isOpen, onClose: handleClose })

  function handleToggle() {
    const nextOpen = !isOpen

    setOpen(nextOpen)
    onOpenChange(nextOpen)
  }

  function getHandleClickItem({ onClick }) {
    return () => {
      setOpen(false)
      onOpenChange(false)
      domReference.current?.focus()
      onClick()
    }
  }

  return {
    context,
    floatingStyles,
    getFloatingProps,
    getHandleClickItem,
    handleToggle,
    isOpen,
    refs,
  }
}
